import React, { useState } from 'react';
import { MDText } from 'i18n-react';

import { Button, FaceHappyIcon, FaceSadIcon } from '@motorway/mw-highway-code';
import { toast } from '@motorway/mw-highway-code/pre-alpha';

import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import { triggerSHFeedbackModalNoClickedEvent } from 'Services/analytics/events';
import { sendPositiveFeedback } from 'Services/api/serviceHistoryFeedback';

import texts from './ServiceHistoryFeedback.texts';
import { ServiceHistoryFeedbackForm } from './ServiceHistoryFeedbackForm';

import styles from './ServiceHistoryFeedback.module.scss';

const LocalT = new MDText(texts);

const YesIcon = () => <FaceHappyIcon size="small" />;
const NoIcon = () => <FaceSadIcon size="small" />;

interface ServiceHistoryBetaFeedbackProps {
	onDismissModal?: () => void;
}

export const ServiceHistoryFeedback: React.FC<ServiceHistoryBetaFeedbackProps> = ({ onDismissModal }) => {
	const { id } = useVehicleData();
	const [isFeedbackFormVisible, setIsFeedbackFormVisible] = useState(false);

	const onSendPositiveFeedback = () =>
		sendPositiveFeedback(id)
			.then(() => {
				toast({
					content: LocalT.translate('toast.success.content'),
					heading: LocalT.translate('toast.success.heading'),
					variant: 'success',
				});
				onDismissModal?.();
			})
			.catch(() => {
				toast({ content: LocalT.translate('toast.error'), variant: 'error' });
				onDismissModal?.();
			});

	const onNoClicked = () => {
		triggerSHFeedbackModalNoClickedEvent();
		setIsFeedbackFormVisible(true);
	};

	return (
		<section className={styles.feedbackBar}>
			<h6 className={styles.heading}>{LocalT.translate('feedbackBar.heading')}</h6>
			<p className={styles.subheading}>{LocalT.translate('feedbackBar.subheading')}</p>
			<p className={styles.question}>{LocalT.translate('feedbackBar.question')}</p>
			<section className={`${styles.buttons} ${isFeedbackFormVisible && styles.active}`}>
				<Button
					icon={YesIcon}
					label={LocalT.translate('feedbackBar.buttons.yes')}
					onClick={onSendPositiveFeedback}
					reverse={true}
					variant="secondary"
				/>
				<Button
					icon={NoIcon}
					label={LocalT.translate('feedbackBar.buttons.no')}
					onClick={onNoClicked}
					reverse={true}
					variant="secondary"
				/>
			</section>
			{isFeedbackFormVisible && <ServiceHistoryFeedbackForm enquiryId={id} onDismissModal={onDismissModal} />}
		</section>
	);
};
